module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona-card-4631dce82df6d3348f1e43e7ff323e0d.webp";